import { trpc } from '@/shared/api/trpc';

export const useCreateAllowlist = () => {
  const utils = trpc.useUtils();
  return trpc.accounts.createAllowlist.useMutation({
    onSettled: () => {
      utils.accounts.listAllowlist.invalidate();
      utils.accounts.list.invalidate();
      utils.accounts.listForFilters.invalidate();
    },
  });
};
